import { render, staticRenderFns } from "./UcCompanyFormContracts.yaml?vue&type=template&id=d9e3ca22&component"
import script from "./UcCompanyFormContracts.yaml?vue&type=script&lang=ts&component"
export * from "./UcCompanyFormContracts.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports